import React, { useState } from 'react';
import cn from 'classnames';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ReactComponent as Delete } from '@assets/images/delete.svg';
import { TouchableButton } from '@components/common/Touchable';
import { LABEL, CUSTOM_MESSAGES } from '@veriables';
import { deleteAllItems } from './CartActionHandler';
import { finaliseOrder } from './CartPaymentHandler';
import { changeCheckOrdersTab } from '@reducers/orders';
import style from './CartButtons.module.scss';
import ActionConfirmationModal from '../Modals/ActionConfirmationModal/index';

const whiteFontStyle = {
  color: 'rgb(255, 255, 255)',
  fontSize: '13.5px',
  fontWeight: 500,
  whiteSpace: 'nowrap',
  lineHeight: 1,
  textAlign: 'center',
  overflow: 'visible',
};

const ToGoModeActions = ({
  cart,
  serverAppTheme,
  changeCheckOrdersTab,
  isCheckBoxClicked,
  checkedItems,
  resetCheckBoxState,
}) => {
  const [deleteModal, setDeleteModal] = useState({ isOpen: false });
  const navigate = useNavigate();
  const cartLength = cart?.length ?? 0;
  const selectedItems =
    cart?.reduce((sum, item) => sum + item.quantity, 0) ?? 0;
  const isCartEmpty = cartLength === 0;

  const checkedItemsQuantity = isCheckBoxClicked
    ? cart
        ?.filter(
          item => checkedItems?.[item.id] || checkedItems?.[item.internalId]
        )
        .reduce((sum, item) => sum + (item.quantity || 0), 0) ?? 0
    : null;

  const deleteCount =
    checkedItemsQuantity !== null ? checkedItemsQuantity : selectedItems;

  const handleDelete = () => {
    setDeleteModal({ isOpen: false });
    deleteAllItems(isCheckBoxClicked ? checkedItems : null);
    changeCheckOrdersTab({ isPendingList: false });
    resetCheckBoxState?.(false);
  };

  const handleFinalise = () => {
    finaliseOrder({
      isDriveThru: false,
      isCounter: false,
      isTogo: true,
      driveThruSelections: {},
      navigate,
    });
    window.sessionStorage.removeItem('menuScrollTop');
  };

  return (
    <div className="col-12 px-0 d-flex flex-column" style={{ gap: '4px' }}>
      <div className="col-12 px-0">
        <TouchableButton
          type="button"
          onClick={e => {
            e.preventDefault();
            setDeleteModal({ isOpen: true });
          }}
          disabled={isCartEmpty}
          className={cn(style.bottomBtn, 'px-0')}
          style={{
            backgroundColor: isCartEmpty
              ? 'rgb(177, 177, 177)'
              : 'rgb(116, 164, 255)',
            width: '100%',
            height: '40px',
            borderRadius: '4px',
            padding: '2.5px 5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px',
            ...whiteFontStyle,
          }}
          rippleEffect={true}
        >
          {isCheckBoxClicked ? (
            `${LABEL().DELETE} (${deleteCount})`
          ) : (
            <>
              <Delete
                fill={
                  isCartEmpty
                    ? serverAppTheme?.btn_font_color_disabled
                    : serverAppTheme?.btn_font_color
                }
                width={18}
                height={18}
              />
              {!isNaN(deleteCount) ? `(${deleteCount})` : ''}
            </>
          )}
        </TouchableButton>
      </div>

      <div className="col-12 px-0 mt-1">
        <TouchableButton
          type="button"
          onClick={e => {
            e.preventDefault();
            handleFinalise();
          }}
          disabled={isCartEmpty}
          className={cn(style.bottomBtn, 'px-0')}
          style={{
            background: isCartEmpty
              ? 'rgb(177, 177, 177)'
              : serverAppTheme?.enabledPayBtn,
            width: '100%',
            height: '40px',
            color: 'rgb(255, 255, 255)',
            fontSize: '20px',
            fontWeight: '500',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '4px',
          }}
          rippleEffect={true}
        >
          {LABEL().FINALIZE_ORDER}
        </TouchableButton>
      </div>
      {deleteModal?.isOpen && (
        <ActionConfirmationModal
          isOpen={deleteModal?.isOpen}
          onClose={() => setDeleteModal({ isOpen: false })}
          data={null}
          customMessage={
            isCheckBoxClicked
              ? CUSTOM_MESSAGES().SINGLE_SELECTED_DELETE_MSG
              : CUSTOM_MESSAGES().DELETE_MULTIPLE_MSG
          }
          handleSubmit={handleDelete}
        />
      )}
    </div>
  );
};

const mapStateToProps = ({ orders, theme }) => ({
  cart: orders.cart,
  serverAppTheme: theme.serverAppTheme,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ changeCheckOrdersTab }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ToGoModeActions);
